import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsTool, PmsTool } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsTool>
    useData={usePmsTool}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
